import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Divider, Link, Paper, Typography } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { BRAND_COLORS, BRAND_GRADIENT } from '../../constants/branding';
import EapLogo from '../../components/brand/EapLogo';
import { AVISO_PRIVACIDAD } from '../../content/avisoPrivacidad';

const PrivacyNoticePage: React.FC = () => {
  const { isLoggedIn } = useAuth();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: BRAND_COLORS.canvas, py: { xs: 3, md: 5 } }}>
      <Container maxWidth="md">
        <Paper elevation={2} sx={{ p: { xs: 3, md: 5 }, borderRadius: 2 }}>
          <Box
            sx={{
              background: BRAND_GRADIENT,
              color: 'common.white',
              borderRadius: 2,
              px: { xs: 2.5, md: 4 },
              py: 3,
              mb: 4
            }}
          >
            <EapLogo variant="stacked" inverted markSize={56} />
            <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mt: 2, color: 'common.white' }}>
              {AVISO_PRIVACIDAD.title}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1, color: 'common.white', opacity: 0.92 }}>
              {AVISO_PRIVACIDAD.responsible}
            </Typography>
            <Typography variant="body2" sx={{ color: 'common.white', opacity: 0.92 }}>
              Última actualización: {AVISO_PRIVACIDAD.lastUpdatedLabel}
            </Typography>
          </Box>

          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            {AVISO_PRIVACIDAD.intro}
          </Typography>

          {AVISO_PRIVACIDAD.sections.map((section) => (
            <Box key={section.title} component="section" sx={{ mb: 3 }}>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 700, color: 'primary.main', mb: 1 }}>
                {section.title}
              </Typography>
              {section.paragraphs.map((paragraph) => (
                <Typography key={paragraph} variant="body1" sx={{ mb: 1.5, lineHeight: 1.7 }}>
                  {paragraph}
                </Typography>
              ))}
            </Box>
          ))}

          <Divider sx={{ my: 3 }} />

          <Link
            component={RouterLink}
            to={isLoggedIn ? '/' : '/login'}
            sx={{ fontWeight: 600, textDecoration: 'none' }}
          >
            {isLoggedIn ? 'Volver al sistema' : 'Volver al inicio de sesión'}
          </Link>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyNoticePage;
